import React, { useState } from "react";
import { List } from "@material-ui/core";
import { WHITE } from "../../../theme";
import { LogOut, HelpCircle, AlertCircle, ShoppingBag } from "react-feather";
import { routes } from "../../../shared/utils/Constants";
import { Redirect } from "react-router-dom";
import SidebarItem from "./SidebarItem";
import NestedSidebarListItems from "./NestedSidebarListItems";

const RepresentativeSidebarListItems = props => {
  const { setOpenDrawer, logout } = props;
  const [redirect, setRedirect] = useState(null);

  return (
    <List>
      <NestedSidebarListItems 
        name="Saldo a vender" 
        divider 
        icon={<ShoppingBag className="mr-4" color={WHITE} size={28} />}
      >
        <SidebarItem
          icon={<AlertCircle color={WHITE} size={28} className="pl-1" />}
          name="Limites e Forecast"
          handleClick={() => {
            setOpenDrawer(false);
            setRedirect(<Redirect to={routes.sellingBalance} />);
          }}
          divider
          isSubMenuItem
        />
        {/* <SidebarItem
          icon={<Search color={WHITE} size={28} className="pl-1" />}
          name="Pesquisa"
          handleClick={() => {
            setOpenDrawer(false);
            setRedirect(<Redirect to={routes.sellingBalanceSearch} />);
          }}
          divider
          isSubMenuItem
        />  */}
      </NestedSidebarListItems>

      {/* <SidebarItem
        icon={<Mail color={WHITE} size={28} className="pl-1" />}
        name="Mensagens"
        handleClick={() => {
          setOpenDrawer(false);
          setRedirect(<Redirect to={routes.consultantMessage} />);
        }}
        divider
      /> */}

      <SidebarItem
        icon={<HelpCircle color={WHITE} size={28} className="pl-1" />}
        name="Ajuda"
        handleClick={() => {
          window.open(
            "https://yara.sharepoint.com/teams/CCE-ExcelenciaComercial/SitePages/0%20-%20Estrat%C3%A9gia.aspx?xsdata=MDV8MDJ8fDg5MWNhOWMxYTIxZDQxMWFhYzhiMDhkZGY0OTkyNGQ3fGVmOGE1M2VhMWExYzQxODliNzkyYzgzMmRjYWVhNTY4fDB8MHw2Mzg5MzU2NjA3NDE3Njk5MTZ8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T21ZNU56YzNNR1JtTFRCbU5UVXRORGsxWVMxaU1UZ3lMV1F3TlRoaFpUQTFZekUzWVY5bVlUVXlZelZpTnkxaFl6VmpMVFJpTnpNdE9XSXdOeTAxTmpJeFpUTTJOVEExWlRkQWRXNXhMbWRpYkM1emNHRmpaWE12YldWemMyRm5aWE12TVRjMU56azJPVEkzTXpZeE1RPT18YzdiNWM3YjBiYzM1NDdjYjQ4ODQwOGRkZjQ5OTI0ZDd8MDk3OGYxMjJlZTIyNGY5ZmI0NjdkODNlOGY3ZmVlM2Y%3D&sdata=UkRIdWpUTlY5TnpRbjRaMWZzT1FKTEtKYUR1VjFxUmtNR2gvMVZnS05aUT0%3D&ovuser=ef8a53ea-1a1c-4189-b792-c832dcaea568%2Ca857508%40yara.com&OR=Teams-HL&CT=1759867075515&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNTA5MTExNjAxOCIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D",
            "_blank"
          );
        }}
        divider
      />

      <SidebarItem
        icon={<LogOut color={WHITE} size={28} className="pl-1" />}
        name="Sair"
        handleClick={logout}
      />

      {redirect}
    </List>
  );
};

export default RepresentativeSidebarListItems;
